import React from 'react';
import GeckoTableCellBase from '../_base.jsx';

class GeckoTableCellCustom extends GeckoTableCellBase {
  render() {
    return (
      <div onClick={(event) => event.stopPropagation()}>
        {this.renderValue()}
      </div>
    );
  }
}

export default GeckoTableCellCustom;
